import { render, staticRenderFns } from "./AutoTaggingCustomValue.vue?vue&type=template&id=6b6b371b&scoped=true&"
import script from "./AutoTaggingCustomValue.vue?vue&type=script&setup=true&lang=js&"
export * from "./AutoTaggingCustomValue.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AutoTaggingCustomValue.vue?vue&type=style&index=0&id=6b6b371b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6b371b",
  null
  
)

export default component.exports